<ion-header>
  <ion-toolbar>
    <ion-title>
      @if(editModal) { 
        {{ 'Update Coach' | translate }} 
      } @else { 
        {{ 'Create Coach' | translate }} 
      }
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <!-- Profile Image -->
      <ion-item>
        <div class="upload-image">
          <app-upload-image
            (imageSelected)="imageSelected($event)"
            [userImage]="coach?.profile_image"
          ></app-upload-image>
        </div>
      </ion-item>

      <!-- First name -->
      <ion-item>
        <ion-input
          class="ion-text-right"
          autocapitalize="true"
          formControlName="first_name"
          name="First Name"
          placeholder="First name"
        >
          <div slot="label">
            First Name <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <!-- Last name -->
      <ion-item>
        <ion-input
          class="ion-text-right"
          autocapitalize="true"
          formControlName="last_name"
          name="Last Name"
          placeholder="Last name"
        >
          <div slot="label">
            Last Name <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-select
          formControlName="sex"
          interface="popover"
          placeholder="Select gender"
        >
          <div slot="label">Gender <ion-text color="danger">*</ion-text></div>
          <ion-select-option value="M">{{ 'Male' | translate }}</ion-select-option>
          <ion-select-option value="F">{{ 'Female' | translate }}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      color="primary m-250"
      (click)="submit()"
      expand="block"
      translate
    >
      @if (!submittingForm) { 
        @if (!isEdit) { 
          {{ 'Save' | translate }} 
        } @else { 
          {{ 'Update' | translate }} 
        } 
      } @else {
        <ion-spinner name="crescent"></ion-spinner>
      }
    </ion-button>
  </ion-toolbar>
</ion-footer>
